import _ from 'lodash'
import KeyDisplay from 'scoreboard/datasets/key-display'
import isNumericDataType from 'scoreboard/components/is-numeric-data-type'
import momentHelper from 'scoreboard/components/moment-helper'
import formatValue from 'scoreboard/components/format-value'
import escapePreserveLineBreaks from 'scoreboard/components/escape-preserve-line-breaks'
import clusterLabel from 'scoreboard/datasets/edit/fields/cluster-label'
import calendars from 'scoreboard/components/calendars'
import isGeographicOrRollup from '../is-geographic-or-rollup'

import DataType from 'scoreboard/datasets/model/data-type'
const { TEXT, YES_NO, DATE, TIME, DATE_TIME, CALENDAR_PERIOD, CLUSTER, PERCENT, CURRENCY,  } = DataType;

class FieldValueFormatter {

	/**
	 * A formatter for field values
	 *
	 * @constructs
	 *
	 * @param {Dataset} model
	 *
	 * @param {Object<Number,Object>} treeItemsById is a hash where keys are
	 * tree IDs and values are tree items
	 */
	constructor(model, treeItemsById) {
		this.model = model
		var filtersByFieldId = _.keyBy(this.filters, 'fieldId')
		this.keyDisplays = _.transform(this.model.get('fields'), (result, field) => {
			field = this.model.getUnderlyingField(field)
			if (isGeographicOrRollup(field.dataType)) {
				result[field.id] = new KeyDisplay({
					model: this.model,
					field: field,
					// filter may be null, which is fine
					filter: filtersByFieldId[field.id],
					treeItemsById
				})
			}
		}, {})
	}

	format(field, value) {
		field = this.model.getUnderlyingField(field) // #35776
		var dataType = field.dataType
		var formattedValue = value
		if (isNumericDataType(dataType) || dataType === YES_NO) {
			// #46835 maintain formatting for primary key if percent or currency datatype
			let alwaysFormat = dataType == CURRENCY || dataType == PERCENT
			if (!field.primaryKey || alwaysFormat) {
				formattedValue = formatValue({
					value, dataType,
					shorten: false,
					precision: field.precision,
					currencyCode: field.currencyCode
				})
			}
		} else if (dataType === DATE) {
			formattedValue = momentHelper.formatDate(value)
		} else if (dataType === TIME) {
			const format = momentHelper.getTimeFormat(field.timeDisplayType)
			formattedValue = momentHelper.formatTime(value, format)
		} else if (dataType === DATE_TIME) {
			const format = momentHelper.getTimeFormat(field.timeDisplayType)
			formattedValue = momentHelper.formatDateTime(value, field.timeZone, format)
		} else if (isGeographicOrRollup(dataType)) {
			if (value == null) {
				formattedValue = ''
			} else {
				var keyDisplay = this.keyDisplays[field.id]
				formattedValue = keyDisplay.labelAndKeys(value)
			}
		} else if (dataType === CALENDAR_PERIOD) {
			formattedValue = _.get(calendars.periodsById[value], 'label', '')
		} else if (dataType === TEXT) {
			formattedValue = escapePreserveLineBreaks(value)
		} else if (dataType === CLUSTER) {
			return clusterLabel(value,  field.clusterLabels)
		}
		return formattedValue
	}
}

export default FieldValueFormatter

FieldValueFormatter.__filename__ = 'datasets/records/field-value-formatter.js'
